
const state = {
  roler: 'user'

}
const mutations = {
  setRoler (state, res) {
    state.roler = res
  }
}

const actions = {
  'setRoler': function ({
    commit
  }, res) {
    commit('setRoler', res)
  }
}

const getters = {
  roler: state => state.roler
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js